import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { List } from 'immutable';

import { shouldShowPriceExcludingTax } from 'selectors/features';
import { selectVenueCheckoutTerms } from 'selectors/root';
import { canShowCouponField } from 'selectors/order';
import { orderReview } from 'actions/order';

import globalMessages from 'components/globalMessages';
import Donations from 'components/Donations';
import { SummaryContainer, Title, StyledTaxBreakdown } from './styles';
import { CheckoutTerms } from '../styles';

import messages from '../messages';
import ProductLineItem from './ProductLineItem';
import PriceLineItem from './PriceLineItem';
import TaxBreakdown from '../TaxBreakdown';
import Payments from './Payments';
import Charges from './Charges';

const OrderSummary = ({
  productItems,
  promotionalItems,
  chargeItems,
  orderTotal,
  remainingTotal,
  taxTotal,
  taxBreakdown,
  checkoutTerms,
  openCart,
  showEdit,
  isTaxExcluded,
  isTab,
  loyaltyPromotionItems,
  payments,
}) => {
  const { tabSummary, orderSummary } = globalMessages;

  return (
    <>
      <SummaryContainer>
        <Title>
          <FormattedMessage {...(isTab ? tabSummary : orderSummary)} />
        </Title>
        {!productItems.size ? (
          <p>
            <FormattedMessage {...messages.emptyOrder} />
          </p>
        ) : (
          <div>
            {productItems.map(item =>
              item.get('key') === 'donation' ? null : (
                <ProductLineItem key={`product-${item.get('id')}`} item={item} />
              )
            )}

            {promotionalItems.map(item => (
              <ProductLineItem key={`promotion-${item.get('id')}`} item={item} />
            ))}

            {loyaltyPromotionItems.map(item => (
              <ProductLineItem key={`loyalty-${item.get('id')}`} item={item} />
            ))}

            <Charges chargeItems={chargeItems} />

            <Donations />

            <PriceLineItem text={<FormattedMessage {...messages.subTotal} />} price={orderTotal} />

            {taxTotal !== 0 && (
              <StyledTaxBreakdown>
                <TaxBreakdown taxBreakdown={taxBreakdown} taxTotal={taxTotal} isTaxExcluded={isTaxExcluded} />
              </StyledTaxBreakdown>
            )}

            {isTab && !payments.isEmpty() && (
              <>
                <Payments payments={payments} />
                <PriceLineItem
                  text={<FormattedMessage {...messages.remainingTotal} />}
                  price={remainingTotal}
                />
              </>
            )}

            {checkoutTerms && <CheckoutTerms dangerouslySetInnerHTML={{ __html: checkoutTerms }} />}
          </div>
        )}
      </SummaryContainer>

      {showEdit && (
        <button className="u-textUnderline" type="button" onClick={openCart}>
          <FormattedMessage {...messages.editOrder} />
        </button>
      )}
    </>
  );
};

OrderSummary.defaultProps = {
  showEdit: true,
  showCoupon: false,
  productItems: new List(),
  loyaltyPromotionItems: new List(),
  chargeItems: new List(),
  promotionalItems: new List(),
  taxTotal: 0,
  taxBreakdown: new List(),
  isTab: false,
  payments: new List(),
};

OrderSummary.propTypes = {
  showCoupon: PropTypes.bool,
  productItems: PropTypes.instanceOf(List),
  chargeItems: PropTypes.instanceOf(List),
  promotionalItems: PropTypes.instanceOf(List),
  loyaltyPromotionItems: PropTypes.instanceOf(List),
  orderTotal: PropTypes.number.isRequired,
  remainingTotal: PropTypes.number,
  taxTotal: PropTypes.number,
  taxBreakdown: PropTypes.instanceOf(List),
  checkoutTerms: PropTypes.string,
  openCart: PropTypes.func,
  showEdit: PropTypes.bool,
  isTaxExcluded: PropTypes.bool,
  isTab: PropTypes.bool,
  payments: PropTypes.instanceOf(List),
};

export default connect(
  (state, { showCoupon }) => ({
    showCoupon: showCoupon && canShowCouponField(state),
    checkoutTerms: selectVenueCheckoutTerms(state),
    isTaxExcluded: shouldShowPriceExcludingTax(state),
  }),
  { openCart: orderReview }
)(OrderSummary);
